import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";
import {
    _dataFromMap,
    _initSplitBarEvent,
} from "../comJs";
import GridPanelUtils from "../../../jsCom/goAclDialog/components/gridPanelUtils";
import GoTabUrl from "../goTabsUrl";

class JobLevelTab extends TabCell {
    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);



        let tabCellId="jobLevel";
        this.tabIdName = tabCellId;
        this.tabLabel = _dataFromMap[tabCellId];

        this.dataFrom = "jobLevel";
        this.dataFromLabel = "职务";

        this.hasType=vueObj.hasType;
        this.active = false;
        this.hasSaveGroup = false;
        this.goTabs = goTabs;
    }

    getLeftCellContent(panelHeight) {
        //缓存其panel的高度
        this.leftTopCellHeight = parseFloat(panelHeight + "") - 40;
        return `${GridPanelUtils.initLeftCellContent(this, this.leftTopCellHeight + "px", this.leftTopCellHeight - 5 + "px", "请输入职务级别名称", this.tabId, false, 160, 180)}`;
    }


    getRightCellContent(panelHeight) {
        return this._getRightCellContent(panelHeight, this);
    }

    /**
     * 初始化职务级别表格
     */
    initJobLevelGrid() {
        let cellObj = this;
        //待选数据
        cellObj.itemConfig["selJobLevel"]=true;
        cellObj.itemConfig["selLeftTopRecord"]=true;
        cellObj.leftTopGrid = GridPanelUtils.initJobLevelGrid(cellObj, true, true, true, true);
    }

    /**
     * 查询待选择的数据
     */
    searchWaitForUser() {
        this.leftTopGrid.reloadData(GridPanelUtils.getLoadGridParams(this, null, "jobLevel"));
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        let cellObj = this;
        //待选数据
        this.initJobLevelGrid();
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), this);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70, searchFun: function () {
                (cellObj).searchWaitForUser();
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        this.initCtlEvent();
    }


    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);
    }

    allCheckBoxClick() {
    }

    //将数据添加到已选表格中
    addLeftTopRecordToAlreadyGrid(rowId, orgGrid) {
        GridPanelUtils._addLeftTopRecordToAlreadyGrid(this, rowId, orgGrid, "职务", "name","jobLevel");
    }

    /**
     * 选中账套信息
     * @param nodeId
     * @param cellObj
     */
    changeAccountEvent(nodeId, cellObj) {
        if (AssertUtils.isNotEmpty(nodeId)) {
            this.initFirstData = true;
            cellObj.leftTopGrid.flushGridByUrl({
                url: GoTabUrl.queryJobLevelByAccountId(nodeId),
                params: GridPanelUtils.getLoadGridParams(cellObj, nodeId, "jobLevel")
            });
        }
    }

    destructionTab() {
        //销毁公共组件
        this._desCommonCtl();
        //销毁岗位列表信息
        if (this.leftTopGrid != null && AssertUtils.isFunction(this.leftTopGrid.destructor)) {
            this.leftTopGrid.destructor();
            this.leftTopGrid = null;
        }
    }

    removeSelectedRecord(rId) {
        this.leftTopGrid.setRowIsNotSelected(rId);
    }
}

function initJobLevelTab(goTabs, vueObj) {
    let groupTab = new JobLevelTab(vueObj, goTabs);
    goTabs.addTabToFactory("jobLevel", groupTab);
}

export default initJobLevelTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/jobLevelTab.js